import { NonEmptyArray } from "./index";

const toArray = <A>(as: NonEmptyArray<A>): Array<A> => as;

export default toArray;
